// extracted by mini-css-extract-plugin
module.exports = {"container":"popup_container__3qB6n","popup":"popup_popup__PD_IV","overflow":"popup_overflow__7rk0E"};